import cx from 'classnames';

interface Props {
  children: React.ReactElement<any> | number | string | (React.ReactElement<any> | number | string)[];
  bgColor?: string;
  bgImage?: string;
  className?: string;
}

const Section = ({ children, bgColor, className, bgImage }: Props) => {
  return (
    <section
      style={{
        ...(bgImage && { backgroundImage: `url(${bgImage})` }),
        ...(bgColor && { backgroundColor: bgColor }),
      }}
      className={cx(className)}
    >
      {children}
    </section>
  );
};

export default Section;
